import ModuleLayout, { syncfusionTabItemsConverter } from 'components/Common/ModuleLayout/ModuleLayout';

import AuditHistory from './AuditHistory';
import RetryFailedRuns from './FailedRunHandlers/RetryFailedRuns';
import FaxTransactionHistory from './FaxTransactionHistory';

const TAB_ITEMS = [
    {
        header: {
            text: 'Automation Monitor',
        },
        cssClass: 'nonClosableTab',
        content: () => (
            <div className='tabDiv'>
                <RetryFailedRuns />
            </div>
        ),
    },
    /*
    {
        header: {
            text: 'Automation Monitor',
        },
        cssClass: 'nonClosableTab',
        content: () => (
            <div className='tabDiv'>
                <WebEnrollmentAdminPortal />
            </div>
        ),
    },
    {
        header: {
            text: 'Requeue',
        },
        cssClass: 'nonClosableTab',
        content: () => (
            <div className='tabDiv'>
                <WebEnrollmentPortal />
            </div>
        ),
    },*/
    {
        header: {
            text: 'Audit History',
        },
        cssClass: 'nonClosableTab',
        content: () => (
            <div className='tabDiv'>
                <AuditHistory />
            </div>
        ),
    },
    {
        header: {
            text: 'Fax Transaction History',
        },
        cssClass: 'nonClosableTab',
        content: () => (
            <div className='tabDiv'>
                <FaxTransactionHistory />
            </div>
        ),
    },
];

const AdminAndSupportAdminPortal = () => {
    return (
        <section>
            <ModuleLayout
                header='Web Enrollment Portal'
                tabs={syncfusionTabItemsConverter(TAB_ITEMS)}
            />
        </section>
    );
};

export default AdminAndSupportAdminPortal;
